import React, { useEffect, useState } from 'react';
import {
    Col,
    Container,
    Row,
    Label,
    Card,
    CardBody
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useNavigate, useParams } from "react-router-dom";
import { isEmpty } from 'lodash';

import { getSapUser } from "helpers/UAM/user.helper";

export default function ViewUser() {
    document.title = "User Profile | DMS";
    const navigate = useNavigate();

    const {roleName}= JSON.parse(localStorage.getItem("user"))

    const [dataInfo, setDataInfo] = useState();

    const { id } = useParams();

    const userId = !isEmpty(id) ? atob(id) : null;


    async function getUserInfo(userId) {
        const response = await getSapUser({ id: userId });
        if (response.status) {
            setDataInfo(response.data);
        }
    }

    useEffect(() => {
        getSapUser();
        if (!isEmpty(userId)) {
            getUserInfo(userId);
        }
    }, [userId]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="User" breadcrumbItem="View User" />
                    <Card>
                        <CardBody>
                            <Row className="mb-4">
                                <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-3 col-form-label label w-100 label-styling"
                                    >
                                        Employee Name
                                    </Label>
                                    <p>{`${dataInfo?.firstName || ""} ${dataInfo?.lastName || ""}` || "-"}</p>
                                </Col>
                                <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-3 col-form-label label label-styling"
                                    >
                                        Employee Id
                                    </Label>
                                    <p>{dataInfo?.userId || "-"}</p>
                                </Col>
                                <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-3 col-form-label label label-styling"
                                    >
                                        Email
                                    </Label>
                                    <p>{dataInfo?.email || "-"}</p>
                                </Col>
                                <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-3 col-form-label label label-styling w-50"
                                    >
                                        Mobile Number
                                    </Label>
                                    <p>{dataInfo?.mobileNo || "-"}</p>

                                </Col>
                            
                                <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-3 col-form-label label label-styling"
                                    >
                                        Role
                                    </Label>
                                    <p>{dataInfo?.roleRole?.roleName || "-"}</p>
                                </Col>
                                <Col sm={5} md='4' >
                                    <Label
                                        className="col-sm-3 col-form-label label label-styling"
                                    >
                                        Region
                                    </Label>
                                    <p>{dataInfo?.region?.join(', ') || "-"}</p>
                                </Col>
                                {dataInfo?.roleRole?.roleName == "sales_representative" && <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-6 col-form-label label label-styling"
                                    >
                                        Sales Office Name
                                    </Label>
                                    <p>{dataInfo?.salesOfficeName?.join(', ') || "-"}</p>
                                </Col>}
                                <Col sm={5} md='4'>
                                    <Label
                                        className="col-sm-3 col-form-label label label-styling"
                                    >
                                        Report to
                                    </Label>
                                    <p>{`${dataInfo?.reportsToUser?.firstName || "-"} ${dataInfo?.reportsToUser?.lastName || " "}`}</p>
                                </Col>
                            </Row>


                            <Row>
                                <Col>
                                    <div>
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={() => {
                                                navigate(`/${roleName}/users`)
                                            }}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </React.Fragment >
    );
}
